import { createClient } from "@connectrpc/connect";
import { IDeleteService } from "../../../../abstractions/services/actions/IDeleteService";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../comun/services/grpc/mapConnectError";
import { VentaAnimalesService } from "../../../../generated/grpc/pesaje_ganaderia_pb";
import { grpcVentaAnimalesDatabase } from "../database/GrpcVentaAnimalesDatabase";
import { VentaAnimalesResponse } from "../response/VentaAnimalesResponse";
import { fx_aplicarCambiosMovimientoAsync } from "./aplicarCambiosMovimiento";

/** Variante gRPC-Web de `VentaAnimalesDeleteService` (ver ese archivo).
 *  `deleteOneAsync` la saca de `GrpcVentaAnimalesDatabase` y
 *  `fx_aplicarCambiosMovimientoAsync` escribe lo que el server cambió aparte,
 *  que viene en la respuesta (2026-10-08): el potrero y sus compras
 *  recalculados, y las ventas que quedan, con los códigos renumerados. Antes
 *  las ventas se marcaban para pedirlas después. */
export class VentaAnimalesDeleteGrpcService
  implements IDeleteService<VentaAnimalesResponse>
{
  async deleteAsync(item: VentaAnimalesResponse): Promise<void> {
    const client = createClient(VentaAnimalesService, grpcTransportProvider.get());

    let respuesta;
    try {
      respuesta = await client.eliminar({ id: item.id });
    } catch (error) {
      throw mapConnectError(error);
    }

    await grpcVentaAnimalesDatabase.deleteOneAsync(item.id);
    await fx_aplicarCambiosMovimientoAsync(respuesta);
  }
}
